import { IBoondockFavorite } from '../interfaces/boondock-favorite';
import { Boondock } from './boondock';
import { BoondockPoint } from './boondock-point';
import { User } from './user';

export class BoondockFavorite implements IBoondockFavorite {
  id?: number;
  userId: number;
  user?: User;
  boondockId: number;
  boondock?: Boondock;
  mapPoint?: BoondockPoint;

  constructor(data?: IBoondockFavorite) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IBoondockFavorite): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (data.mapPoint) {
      this.mapPoint = new BoondockPoint(data.mapPoint);
    }
  }
}
